import type { IOrderShareRequest } from '@/models/orders';
import type { ICard } from '../models/cards';
import { createLayupClient } from './layupApi';

export const sendEmail = async (data: any) => {
  const client = createLayupClient(false);
  const response = await client.post('/v1/emails', { data });
  return response.data as ICard;
};

export const sendReviewEmail = async (body: any): Promise<any> => {
  const client = createLayupClient(false);
  const response = await client.post('v1/emails', body);
  return response.data;
};

export const shareOrder = async (data: IOrderShareRequest) => {
  const client = createLayupClient(false);
  const response = await client.post('v1/emails', data);
  return response.data;
};
